export default __webpack_public_path__ + "static/media/Path3360.ab55ee96.svg";